module.exports = __webpack_public_path__ + "static/img/duom02.e788316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom02.png
// module id = 978
// module chunks = 0